import React from 'react'
import PropTypes from 'prop-types'

import Cell from '../styled/Cell'
import Curtain from '../components/Curtain'
import Footer from '../components/Footer'
import Header from '../components/Header'
import Main from '../styled/Main'

function Layout(props = {}) {
  const [loaded, setLoaded] = React.useState(false)
  React.useEffect(() => {
    setLoaded(true)
  }, [setLoaded])

  return (
    <>
      <Curtain loaded={loaded} />
      <Header />
      <Main>
        <Cell maxWidth={props.maxContentWidth}>{props.children}</Cell>
      </Main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  maxContentWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

Layout.defaultProps = {
  maxContentWidth: '56.25rem',
}

export default Layout
